import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Routes from "./Routes";
import "./Css/index.css";

ReactDOM.render(<Routes />, document.getElementById("root"));
